import { Globe } from "lucide-react";
import { useNavigate } from "react-router-dom";

import TaxaResumo from "../components/TaxaResumo";
import { rotaEditarCanal } from "../rotas";

/** iFood e pagamentos online do cardápio: não são formas cadastradas, mas têm taxa e prazo. */
export default function CanaisOnline({ canais }) {
  const navigate = useNavigate();
  if (!canais?.length) return null;
  return (
    <section className="bg-card rounded-xl border shadow-sm" data-e2e="canais-online">
      <div className="p-5 border-b flex items-start gap-2.5">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0"><Globe className="w-5 h-5 text-primary" /></div>
        <div>
          <h2 className="text-base font-bold">Vendas online e marketplace</h2>
          <p className="text-xs text-muted-foreground">Taxa e prazo do iFood e dos pagamentos feitos pelo cliente no cardápio digital. Entram no DRE e no Fluxo de Caixa.</p>
        </div>
      </div>
      <ul className="divide-y">
        {canais.map((c) => (
          <li key={c.chave} className="px-5 py-3 flex items-center gap-3 flex-wrap">
            <div className="flex-1 min-w-[180px]">
              <p className="font-medium">{c.nome}</p>
              <p className="text-xs text-muted-foreground">{c.descricao}</p>
            </div>
            <TaxaResumo item={c} onClick={() => navigate(rotaEditarCanal(c.chave))} />
          </li>
        ))}
      </ul>
    </section>
  );
}
